module.exports = __webpack_public_path__ + "static/media/5.ca0bddea.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shoes/5.png
// module id = 1541
// module chunks = 0